import { render } from "./Row.vue?vue&type=template&id=51dd94fa"
import script from "./Row.vue?vue&type=script&lang=js"
export * from "./Row.vue?vue&type=script&lang=js"
script.render = render

export default script